import { Box } from '@mui/material'
import ColourSettings from './ColourSettings'
import PrinterSettings from './PrinterSettings'
import ResetAllSettings from './ResetAllSettings'

function Settings() {
  return (
    <Box
      sx={{
        maxWidth: 'sm',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <ColourSettings />
      <PrinterSettings />
      <ResetAllSettings />
    </Box>
  )
}

export default Settings
